import { validateEmail } from "helpers/email";
import { validateUrlXXX } from "helpers/url";
import { validateContractCode } from "helpers/validators";

const validate = (values = {}) => {
	const errors = {};

	if (!values.name) errors.name = "Informe o modelo do contrato";

	if (!values.startDate) errors.startDate = "Informe a data de inicio";

	if (values.selfRenewable) {
		if (!values.lifespan)
			errors.lifespan = "Informe a duração da vigência (em meses)";
	} else {
		if (!values.due) errors.due = "Informe data de fim do contrato";
	}
	if (
		!values.useOwnContract &&
		!values.externalId &&
		validateContractCode(values.externalId)
	)
		errors.externalId = "Informe o código do contrato";
	if (!values.useOwnContract && !values.hirerContractURL)
		errors.hirerContractURL = "Informe o link do contrato do contratante";
	if (!values.useOwnContract && validateUrlXXX(values.hirerContractURL))
		errors.hirerContractURL = "Informe um link válido";
	if (!values.useOwnContract && !values.hirerContractSignerEmail)
		errors.hirerContractSignerEmail =
			"Informe o e-mail do contratante no ZapSign";
	if (!values.useOwnContract && !validateEmail(values.hirerContractSignerEmail))
		errors.hirerContractSignerEmail = "Informe um email válido";
	if (!values.useOwnContract && !values.hiredContractURL)
		errors.hiredContractURL = "Informe o link do contrato do prestador";
	if (!values.useOwnContract && validateUrlXXX(values.hiredContractURL))
		errors.hiredContractURL = "Informe um link válido";
	if (!values.useOwnContract && !values.hiredContractSignerEmail)
		errors.hiredContractSignerEmail =
			"Informe o e-mail do prestador no ZapSign";
	if (!values.useOwnContract && !validateEmail(values.hiredContractSignerEmail))
		errors.hiredContractSignerEmail = "Informe um email válido";

	return errors;
};

export default validate;
